<template>
    <div class="mt-3 p-4 mb-0 bg-white rounded-lg">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <div class="d-flex justify-content-between">
            <div class="h3 mb-3">Data sources</div>
            <div v-if="dataSources.length">
                <a href="#" @click.prevent="isEditing = !isEditing" v-if="!isEditing">
                    <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                </a>
            </div>
        </div>
        <div>
            <div v-for="(dataSource, index) in dataSources" class="mb-5">
                <div class="d-flex align-items-start mb-3">
                    <div>
                        <input type="checkbox" title="Enable" class="mr-4" v-model="dataSource.enabled">
                    </div>
                    <div class="mr-4">
                        <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                             v-if="isEditing"
                        >
                            <input type="text"
                                   autocomplete="off"
                                   id="newSourceName"
                                   class="form-control border-0 py-0 shadow-none form-input"
                                   v-model="dataSource.name"
                            >
                        </div>
                        <div class="h4" v-else>{{ dataSource.name }}</div>
                    </div>
                    <div class="mr-4">
                        <button type="button" class="btn btn-primary btn-sm"
                                @click="openPopupDataSourceOptions($event, dataSource)">Data source options
                        </button>
                    </div>
                    <div class="mr-4">
                        <button type="button" class="btn btn-primary btn-sm"
                                @click="openPopupShippingMapping($event, dataSource)">Shipping mapping
                        </button>
                    </div>
                    <div class="mr-4">
                        <button type="button" class="btn btn-primary btn-sm"
                                @click="openPopupBookingTypeMapping($event, dataSource)">Booking type mapping
                        </button>
                    </div>
                    <div v-if="!isEditing">
                        <div title="Delete DataSource"
                             class="material-icons-outlined cursor-pointer text-primary"
                             @click="deleteDataSource($event, dataSource)"
                        >
                            delete
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div v-for="(cred, credName) in dataSource.credentials" class="mb-2">
                        <label :for="'source-' + index + '-' + credName" class="h5">{{ credName }}</label>
                        <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                            <input type="text"
                                   autocomplete="off"
                                   :id="'source-' + index + '-' + credName"
                                   class="form-control border-0 py-0 shadow-none form-input"
                                   v-model="dataSource.credentials[credName]"
                                   :disabled="!isEditing"
                                   :class="{view: !isEditing}"
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 d-flex justify-content-center align-items-center mt-3">
                    <button type="button" class="btn btn-primary mr-3"
                            v-if="isEditing" @click="updateDataSources">
                        Update data
                    </button>
                    <a href="#" v-if="isEditing" @click.prevent="isEditing = false">Cancel</a>
                </div>
            </div>
            <br/>
            <br/>
            <div v-if="showCreateForm" class="py-2">
                <div class="form-group bg-light p-3">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="w-25">
                            <label for="newSourceKey" class="h5">Select data source</label>
                            <div class="bg-white rounded-lg div-focus">
                                <v-select
                                    :options="availableDataSources"
                                    v-model="selectedDataSource"
                                    :clearSearchOnSelect="false"
                                    label="name"
                                    placeholder="Select source"
                                    :clearable="false"
                                    @input="onSelectNewDataSource"
                                >
                                </v-select>
                            </div>
                        </div>
                        <div class="w-25">
                            <label for="newSourceName" class="h5">Data source name</label>
                            <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                <input type="text"
                                       autocomplete="off"
                                       id="newSourceName"
                                       class="form-control border-0 py-0 shadow-none form-input"
                                       v-model="newDataSource.name"
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h4">Credentials</div>
                <div class="d-flex flex-wrap align-items-center justify-content-between bg-light p-3" v-if="newDataSource">
                    <div v-for="(cred, credName) in newDataSource.credentials"
                         class="mb-2">
                        <div>
                            <label :for="'newSource' + credName" class="h5">{{ credName }}</label>
                            <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                <input type="text"
                                       autocomplete="off"
                                       :id="'newSource' + credName"
                                       class="form-control border-0 py-0 shadow-none form-input"
                                       v-model="newDataSource.credentials[credName]"
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div v-if="!showCreateForm">
                <a v-on:click.prevent="showCreateForm = true"
                   class="btn btn-success d-inline-flex align-items-center" title="Add api key">
                        <span
                            class="material-icons-outlined cursor-pointer text-white mr-1">add_circle_outline</span>
                    <span>Add data source</span>
                </a>
            </div>

            <div v-else class="d-flex align-items-center mt-3">
                <button type="submit" class="btn btn-primary mr-3" @click="createDataSource()">
                    Save
                </button>
                <a href="#" @click.prevent="showCreateForm = false">Cancel</a>
            </div>
        </div>

        <div class="modal fade"
             ref="popupDataSourceOptions"
             id="popupDataSourceOptions"
             tabindex="-1"
             role="dialog"
             aria-labelledby="popupDataSourceOptionsLabel"
             aria-hidden="true"
             :class="{show, 'd-block': activeModal}"
        >
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title h5" id="popupDataSourceOptionsTitle">
                            Data source {{ syncOrdersActive.name }} options
                        </div>
                        <button type="button" class="close" @click="toggleModal($event, 'activeModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="row mb-2">
                            <div class="col">
                                <button type="button" class="btn btn-primary"
                                        @click="syncOrders">Sync all now
                                </button>
                            </div>
                        </div>

                        <hr>

                        <div class="row mb-2">
                            <div class="col">
                                <label for="setCronSyncCustomer">
                                    <strong>Cron setting (run every X minutes)</strong>
                                </label>
                                <div>
                                    <input type="text" class="form-control"
                                           id="setCronSyncCustomer"
                                           placeholder="Cron setting (run every X minutes)"
                                           v-model="setCronSyncOrders">
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col">
                                <label for="setEarliestSaleToImport">
                                    <strong>Earliest order id to import</strong>
                                </label>
                                <div>
                                    <input type="text" class="form-control"
                                           placeholder="Set the earliest id_nota"
                                           id="setEarliestSaleToImport" v-model="setEarliestSaleToImport"
                                           aria-label="Set the earliest id_nota" aria-describedby="basic-addon2">
                                </div>
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <label for="orderTag"><strong>Order tag to import</strong></label>
                                <div>
                                    <div>
                                        <input type="text" class="form-control"
                                               placeholder="Set order tag"
                                               id="orderTag" v-model="orderTag"
                                               aria-label="Set order tag">
                                    </div>
                                </div>
                                <div><i>Don't use a space in the tag name</i></div>
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <label for="shippingMethod"><strong>Shipping method to import</strong></label>
                                <div>
                                    <div>
                                        <input type="text" class="form-control"
                                               placeholder="Shipping method"
                                               id="shippingMethod" v-model="shippingMethod"
                                               aria-label="Shipping method">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <div class="d-flex align-items-center">
                                    <label for="only-unfulfilled" class="mb-0 mr-3">
                                        <strong>Import only unfulfilled orders</strong>
                                    </label>
                                    <input type="checkbox" class="form-control"
                                           style="width: 18px;"
                                           placeholder="Set order tags"
                                           id="only-unfulfilled" v-model="onlyUnfulfilled"
                                           aria-label="Only unfulfilled">
                                </div>
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <label><strong>Select pick-up</strong></label>
                                <div>
                                    <v-select
                                        :options="['Step', 'Customer']"
                                        v-model="pickUp"
                                        :clearable="false"
                                    >
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <hr>

                        <div class="row mb-2">
                            <div class="col">
                                <div>
                                    <strong>Last sync running time:</strong>
                                    <span>{{ lastRunningSyncOrders }} min</span>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col">
                                <div>
                                    <strong>Last time script ran:</strong>
                                    <span>{{ lastTimeSyncOrdersRan }}</span>
                                </div>
                            </div>
                        </div>
                        <hr>


                        <div class="d-flex justify-content-end">
                            <button class="btn btn-primary mr-3" type="button"
                                    @click="saveSyncOrdersOptions">Save
                            </button>
                            <button class="btn btn-secondary float-right" @click="toggleModal($event, 'activeModal')">
                                Back
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade"
             ref="popupShippingMapping"
             id="popupShippingMapping"
             tabindex="-1"
             role="dialog"
             aria-labelledby="popupShippingMappingLabel"
             aria-hidden="true"
             :class="{show, 'd-block': activeShippingMappingModal}"
        >
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title h5" id="popupShippingMappingTitle">
                            Shipping mapping
                        </div>
                        <button type="button" class="close" @click="toggleModal($event, 'activeShippingMappingModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div v-for="(typeName, type) in bookingTypes"
                             v-if="activeShippingMappingDataSource.mapping"
                             class="mb-5">
                            <div class="d-flex justify-content-between mb-4">
                                <h4>{{ typeName }}</h4>
                            </div>
                            <div class="d-flex mb-2">
                                <div style="width: 30%" class="mr-1 text-center"><strong>Shipping</strong></div>
                                <div style="width: 30%" class="mr-1 text-center"><strong>Product</strong></div>
                                <div style="width: 30%" class="mr-1 text-center"><strong>Service</strong></div>
                                <div style="width: 10%" class="text-center"></div>
                            </div>
                            <div v-if="activeShippingMappingDataSource.mapping
                            && activeShippingMappingDataSource.mapping?.[type] != null">
                                <div class="d-flex mb-2"
                                     v-for="(item, index) in activeShippingMappingDataSource.mapping[type].mapping"
                                >
                                    <div style="width: 30%" class="mr-1 text-center">
                                        <input type="text" class="form-control"
                                               placeholder="Shipping method"
                                               style="height: 34px;"
                                               v-model="activeShippingMappingDataSource.mapping[type]['mapping'][index]['shipping']"
                                               aria-label="Shipping method">
                                    </div>
                                    <div style="width: 30%" class="mr-1 text-center">

                                        <v-select
                                            :options="allAvailableProducts[type]"
                                            label="name"
                                            v-model="activeShippingMappingDataSource.mapping[type]['mapping'][index]['product']"
                                            :clearable="false"
                                        >
                                        </v-select>
                                    </div>
                                    <div style="width: 30%" class="mr-1 text-center">
                                        <!--  todo show some placeholder if services are not available or hide column  -->
                                        <v-select
                                            :options="allAvailableServices[type]"
                                            label="name"
                                            v-model="activeShippingMappingDataSource.mapping[type]['mapping'][index]['service']"
                                            :clearable="false"
                                        >
                                        </v-select>
                                    </div>
                                    <div style="width: 10%" class="text-center">
                                        <div title="delete" class="material-icons-outlined cursor-pointer text-primary" @click="deleteShippingMapping($event, type, index)">
                                            delete
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button title="Add mapping"
                                    type="button"
                                    class="btn btn-success d-inline-flex align-items-center mt-3"
                                    @click="addShippingMapping(type)"
                            >
                                <span class="material-icons-outlined cursor-pointer text-white mr-1">
                                    add_circle_outline
                                </span>
                                <span>Add mapping</span>
                            </button>
                        </div>

                        <div class="d-flex justify-content-end">
                            <button class="btn btn-primary mr-3"
                                    type="button"
                                    @click="saveShippingMapping"
                            >Save</button>
                            <button class="btn btn-secondary float-right"
                                    @click="toggleModal($event, 'activeShippingMappingModal')"
                            >Back</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade"
             ref="popupShippingMapping"
             id="popupShippingMapping"
             tabindex="-1"
             role="dialog"
             aria-labelledby="popupShippingMappingLabel"
             aria-hidden="true"
             :class="{show, 'd-block': activeBookingTypeMappingModal}"
        >
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title h5" id="popupShippingMappingTitle">
                            Booking type mapping
                        </div>
                        <button type="button"
                                class="close"
                                @click="toggleModal($event, 'activeBookingTypeMappingModal')"
                                aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div>
                            <div v-for="(typeName, type) in bookingTypes"
                                 v-if="activeBookingTypeMappingDataSource.mapping"
                                 class="mb-5"
                            >
                                <div class="d-flex justify-content-between mb-4">
                                    <h4>{{ typeName }}</h4>
                                    <div class="d-flex align-items-center">
                                        <label :for="`default-booking-type-${type}`" class="mb-0 mr-3">
                                            <strong>Default</strong>
                                        </label>
                                        <input type="checkbox" class="form-control"
                                               style="width: 18px;"
                                               :id="`default-booking-type-${type}`"
                                               v-model="activeBookingTypeMappingDataSource.mapping[type].default"
                                               aria-label="Set default"
                                               @change="onChangeDefaultBookingType($event, type)"
                                        >
                                    </div>
                                </div>
                                <div class="d-flex mb-2">
                                    <div style="width: 45%" class="mr-1 text-center"><strong>Key</strong></div>
                                    <div style="width: 45%" class="mr-1 text-center"><strong>Value</strong></div>
                                    <div style="width: 10%" class="text-center"></div>
                                </div>
                                <div v-for="(item, index) in activeBookingTypeMappingDataSource.mapping[type].mapping" class="d-flex mb-2">
                                    <div style="width: 45%" class="mr-1 text-center">
                                        <v-select
                                            :options="bookingTypeMappingKeys"
                                            v-model="activeBookingTypeMappingDataSource.mapping[type].mapping[index]['key']"
                                            :clearable="false"
                                        >
                                        </v-select>
                                    </div>
                                    <div style="width: 45%"
                                         class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                    >
                                        <input type="text"
                                               autocomplete="off"
                                               style="height: 31px;"
                                               class="form-control border-0 py-0 shadow-none"
                                               v-model="activeBookingTypeMappingDataSource.mapping[type].mapping[index]['value']"
                                        >
                                    </div>

                                    <div style="width: 10%" class="text-center">
                                        <div title="delete"
                                             class="material-icons-outlined cursor-pointer text-primary"
                                             @click="deleteBookingTypeMapping($event, type, index)"
                                        >delete</div>
                                    </div>
                                </div>
                                <button title="Add mapping"
                                        type="button"
                                        class="btn btn-success d-inline-flex align-items-center mt-3"
                                        @click="addBookingTypeMapping($event, type)"
                                >
                                <span class="material-icons-outlined cursor-pointer text-white mr-1">
                                    add_circle_outline
                                </span>
                                    <span>Add</span>
                                </button>
                            </div>
                        </div>


                        <div class="d-flex justify-content-end">
                            <button class="btn btn-primary mr-3"
                                    type="button"
                                    @click="saveBookingTypeMapping"
                            >Save</button>
                            <button class="btn btn-secondary float-right"
                                    @click="toggleModal($event, 'activeBookingTypeMappingModal')"
                            >Back</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeShippingMappingModal || activeModal || activeBookingTypeMappingModal"
             class="modal-backdrop fade show"
        ></div>
    </div>
</template>

<script>
// @todo migrate existing mapping structure to new one (database records update)

export default {
    name: "DataSources",
    props: {
        dataSourcesProp: {type: Array, required: true},
        availableDataSources: {type: Array, required: true},
        clientId: {type: Number, required: false},
        availableProducts: {type: Array, required: true},
        availableServices: {type: Array, required: true},
        allAvailableAgreements: {type: Array, required: true},
        bookingTypes: {type: Object, required: true},
        bookingTypeMappingKeys: {type: Array, required: true},
    },
    data() {
        return {
            isEditing: false,
            showCreateForm: false,
            dataSources: this.dataSourcesProp,
            newDataSource: {},
            selectedDataSource: {},
            setCronSyncOrders: '',
            setEarliestSaleToImport: '',
            pickUp: '',
            lastRunningSyncOrders: '',
            lastTimeSyncOrdersRan: '',
            syncOrdersActive: {},
            activeModal: false,
            show: false,
            orderTag: '',
            shippingMethod: '',
            onlyUnfulfilled: '',
            activeShippingMappingModal: false,
            activeShippingMappingDataSource: false,
            activeBookingTypeMappingModal: false,
            activeBookingTypeMappingDataSource: false,
            allAvailableServices: [],
            allAvailableProducts: [],
        }
    },
    methods: {
        createDataSource() {
            this.$set(this.newDataSource, 'clientId', this.clientId);
            axios.post('/data-source/store', this.newDataSource)
                .then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Data source has been created successful',
                        time: 3000,
                        blockClass: 'flash-message'
                    });
                    this.newDataSource = {};
                    this.selectedDataSource = {};
                    this.showCreateForm = false;
                    this.dataSources.push(response.data.dataSource);
                }).catch((error) => {
                    console.log(error.response);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 3000,
                        blockClass: 'flash-message error'
                    });

            });
        },

        updateDataSources() {
            axios.patch('/data-source/massUpdate', {dataSources: this.dataSources})
                .then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Data sources has been updated successful',
                        time: 3000,
                        blockClass: 'flash-message'
                    });
                    this.isEditing = false;
                }).catch((error) => {
                console.log(error.response);
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message || error.response.data || 'Error',
                    time: 3000,
                    blockClass: 'flash-message error'
                });

            });
        },

        deleteDataSource(e, dataSource) {
            if (confirm(`Are you sure you want to delete the DataSource ${dataSource.name}?`)) {
                axios.delete(`/data-source/${dataSource.id}/delete`)
                    .then((response) => {
                        this.dataSources.forEach((item, key) => {
                            if (item.id == dataSource.id) {
                                this.dataSources.splice(key, 1);
                            }
                        })
                        this.flashMessage.success({
                            title: '',
                            message: 'Data source has been deleted successful',
                            time: 3000,
                            blockClass: 'flash-message'
                        });
                        this.isEditing = false;
                    }).catch((error) => {
                    console.log(error.response);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 3000,
                        blockClass: 'flash-message error'
                    });

                });
            }
        },
        onSelectNewDataSource() {
            this.newDataSource = JSON.parse(JSON.stringify(this.selectedDataSource));
        },
        openPopupDataSourceOptions(e, dataSource) {
            this.syncOrdersActive = dataSource;
            this.setCronSyncOrders = dataSource.settings && dataSource.settings.syncOrders ? dataSource.settings.syncOrders.cronTime : '';
            this.setEarliestSaleToImport = dataSource.settings && dataSource.settings.syncOrders ? dataSource.settings.syncOrders.earliestSaleToImport : '';
            this.pickUp = dataSource.settings && dataSource.settings.syncOrders ? dataSource.settings.syncOrders.pickUp : '';
            this.orderTag = dataSource.settings && dataSource.settings.syncOrders ? dataSource.settings.syncOrders.orderTag : '';
            this.shippingMethod = dataSource.settings && dataSource.settings.syncOrders ? dataSource.settings.syncOrders.shippingMethod : '';
            this.onlyUnfulfilled = dataSource.settings && dataSource.settings.syncOrders ? dataSource.settings.syncOrders.onlyUnfulfilled : '';

            this.lastRunningSyncOrders = dataSource.settings && dataSource.settings.syncOrders && dataSource.settings.syncOrders.lastSyncOrdersRunningTime
                ? (parseInt(dataSource.settings.syncOrders.lastSyncOrdersRunningTime) / 60).toFixed(2)
                : '';

            this.lastTimeSyncOrdersRan = dataSource.settings && dataSource.settings.syncOrders && dataSource.settings.syncOrders.lastTimeSyncOrders
                ? dataSource.settings.syncOrders.lastTimeSyncOrders
                : '';

            this.toggleModal('', 'activeModal');
        },

        openPopupShippingMapping(e, dataSource) {
            this.toggleModal('', 'activeShippingMappingModal');
            this.activeShippingMappingDataSource = {
                dataSourceId: dataSource.id,
                mapping: dataSource.settings && dataSource.settings.shippingMapping ?
                    dataSource.settings.shippingMapping :
                    []
            };

            for (let type in this.bookingTypes) {
                if (!this.activeShippingMappingDataSource.mapping[type]) {
                    this.activeShippingMappingDataSource.mapping[type] = {mapping: []};
                }
            }
        },
        openPopupBookingTypeMapping(e, dataSource) {
            this.toggleModal('', 'activeBookingTypeMappingModal');
            this.activeBookingTypeMappingDataSource = {
                dataSourceId: dataSource.id,
                mapping: dataSource.settings && dataSource.settings.bookingTypeMapping ?
                    dataSource.settings.bookingTypeMapping :
                    {}
            };
            if (!Object.keys(this.activeBookingTypeMappingDataSource.mapping).length) {
                for(let type in this.bookingTypes) {
                    this.activeBookingTypeMappingDataSource.mapping[type] = {default: 0, mapping: []};
                }
            }
        },
        toggleModal(e, modal) {
            const body = document.querySelector("body");
            this[modal] = !this[modal];
            this[modal]
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },

        syncOrders() {
            axios.get(`/data-source/${this.syncOrdersActive.id}/manually-import-orders`)
                .then(response => {
                    this.flashMessage.success({
                        title: '',
                        message: 'The process of syncing orders have been started. It may take some time.',
                        time: 3000,
                        blockClass: 'flash-message'
                    });
                })
                .catch(error => {
                    console.log(error.response);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 3000,
                        blockClass: 'flash-message error'
                    });
                })
        },

        saveSyncOrdersOptions() {
            axios.patch(`/data-source/${this.syncOrdersActive.id}/set-options`, {
                setCronSyncOrders: this.setCronSyncOrders,
                earliestSaleToImport: this.setEarliestSaleToImport,
                pickUp: this.pickUp,
                orderTag: this.orderTag,
                shippingMethod: this.shippingMethod,
                onlyUnfulfilled: this.onlyUnfulfilled,
            })
            .then(response => {
                this.flashMessage.success({
                    title: '',
                    message: 'The process of syncing orders have been started. It may take some time.',
                    time: 3000,
                    blockClass: 'flash-message'
                });
                console.log(response.data);
                if (response.data.dataSources) {
                    this.dataSources = response.data.dataSources;
                }
                this.toggleModal('', 'activeModal');
            })
            .catch(error => {
                console.log(error.response);
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message || error.response.data || 'Error',
                    time: 3000,
                    blockClass: 'flash-message error'
                });
            })
        },
        addShippingMapping(type) {
            let settings = JSON.parse(JSON.stringify(this.activeShippingMappingDataSource));
            settings.mapping[type]['mapping'].push({shipping: '', product: '', service: ''});
            this.$set(this, 'activeShippingMappingDataSource', settings);
        },
        deleteShippingMapping(e, type,  index) {
            this.activeShippingMappingDataSource.mapping[type]['mapping'].splice(index, 1);
        },
        saveShippingMapping() {
            axios.patch(`/data-source/${this.activeShippingMappingDataSource.dataSourceId}/save-shipping-mapping`, {
                    mapping: this.activeShippingMappingDataSource.mapping
                })
                .then(response => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Success',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                    console.log(response.data);
                    if (response.data.dataSources) {
                        this.dataSources = response.data.dataSources;
                    }
                    this.toggleModal('', 'activeShippingMappingModal');
                })
                .catch(error => {
                    console.log(error.response);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 3000,
                        blockClass: 'flash-message error'
                    });
                })
        },
        addBookingTypeMapping(e, type) {
            let settings = JSON.parse(JSON.stringify(this.activeBookingTypeMappingDataSource));
            settings.mapping[type].mapping.push({key: 'Shipping name', value: ''});
            this.$set(this, 'activeBookingTypeMappingDataSource', settings);
        },
        deleteBookingTypeMapping(e, type, index) {
            this.activeBookingTypeMappingDataSource.mapping[type].mapping.splice(index, 1);
        },
        saveBookingTypeMapping() {
            axios.patch(`/data-source/${this.activeBookingTypeMappingDataSource.dataSourceId}/save-booking-type-mapping`, {
                    mapping: this.activeBookingTypeMappingDataSource.mapping
                })
                .then(response => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Success',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                    console.log(response.data);
                    if (response.data.dataSources) {
                        this.dataSources = response.data.dataSources;
                    }
                    this.toggleModal('', 'activeBookingTypeMappingModal');
                })
                .catch(error => {
                    console.log(error.response);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 3000,
                        blockClass: 'flash-message error'
                    });
                })
        },
        onChangeDefaultBookingType(e, type) {
            let settings = JSON.parse(JSON.stringify(this.activeBookingTypeMappingDataSource));
            for (let i in settings.mapping) {
                if (type != i) {
                    settings.mapping[i].default = false;
                }
            }
            this.$set(this, 'activeBookingTypeMappingDataSource', settings);
        },
        extractAvailableAgreementData() {
            const productsMap = {};
            const servicesMap = {};

            this.allAvailableAgreements.forEach(agreement => {
                // It is not obvious - only an agreement type is used for mapping saving, not id attribute.
                // Assuming we will have only one per-type agreement instances here
                if (agreement.products) {
                    // productsMap[agreement.id] = agreement.products;
                    productsMap[agreement.type] = agreement.products;
                }
                if (agreement.services) {
                    // servicesMap[agreement.id] = agreement.services;
                    servicesMap[agreement.type] = agreement.services;
                }
            });

            this.allAvailableProducts = productsMap;
            this.allAvailableServices = servicesMap;
        },

    },
    beforeMount() {
        this.extractAvailableAgreementData();
    }
}
</script>

<style scoped>

</style>
